import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { 
  REQUEST, 
  fetchSuccess, 
  fetchFailure 
} from '../../actions/models/detail';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';
import { Error as ErrorAction } from '../../actions/error/error';

// Worker saga: will be fired on REQUEST actions
function* fetchModelDetail(action) {
  try {
    const { modelId, options = {} } = action.payload;
    const headers = getLocalUser();
    
    if (!headers.Authorization) {
      throw new Error('Authentication token not found');
    }
    
    if (!headers['X-WORKSPACE-ID']) {
      throw new Error('Workspace ID not found');
    }
    
    // Build query string for pagination
    const queryParams = new URLSearchParams();
    
    // Only include training params if explicitly requested
    if (options.include_trainings === true) {
      if (options.trainings_page !== undefined) {
        queryParams.append('trainings_page', options.trainings_page);
      }
      if (options.trainings_per_page !== undefined) {
        queryParams.append('trainings_per_page', options.trainings_per_page);
      }
    } else {
      // Skip trainings by default for performance
      queryParams.append('skip_trainings', 'true');
    }
    
    const queryString = queryParams.toString();
    const urlWithQuery = `${config.API_URL}/pipelines/${modelId}${queryString ? `?${queryString}` : ''}`;
    
    // Use the same endpoint format that's in the backend
    const response = yield call(
      axios.get,
      urlWithQuery,
      { headers }
    );
    
    yield put(fetchSuccess(response.data.data, options));
  } catch (error) {
    console.error('Model detail fetch error:', error);

    yield put(ErrorAction(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

// Watcher saga: will be fired on REQUEST actions
export function* watchModelDetailRequest() {
  yield takeLatest(REQUEST, fetchModelDetail);
}

export default watchModelDetailRequest; 